/**
 * Copyright (c) 2020 TechDivision GmbH
 * All rights reserved
 */

/**
 * @module IFrame
 */
(function () {

    class UC_CookieTracker {

        /**
         * @param id
         * @type string
         */
        constructor(id) {
            this.id = id;
            this.getCurrentCookieState(this.id);
            window.addEventListener('UC_UI_CMP_EVENT', (e) => {
                let uc_eventType = e.detail.type;
                if (uc_eventType === "ACCEPT_ALL" || uc_eventType === "DENY_ALL" || uc_eventType === "SAVE") {
                    this.getCurrentCookieState(this.id);
                }
            })
        };

        /**
         * Get the current cookie status by service id
         * @param id
         * @type string
         */
        getCurrentCookieState(id) {
            let uc_settings = JSON.parse(window.localStorage.getItem('uc_settings'));
            if (uc_settings === null) {
                this.status = null;
            } else {
                let uc_services = uc_settings['services'];
                uc_services.forEach(service => {
                    if (service['id'] === id) {
                        this.status = service['status'];
                    }
                })
            }
        };

    }

    /**
     * Handle navigation
     * @param iFrame
     * @method navigation
     */
    function checkIfUCServiceAccepted(iFrame) {
        var serviceId = iFrame.dataset.ucserviceid;
        var iFrameSrc = iFrame.dataset.url;
        var isBackend = iFrame.dataset.isbackend;
        var cookieTracker = new UC_CookieTracker(serviceId);

        if (serviceId) {
            // If a serviceId is set we check if the related cookie is accepted
            if (cookieTracker.status === true) {
                iFrame.setAttribute("src", iFrameSrc);
                if (iFrame.dataset.hidetopbar === "1") {
                    let iFrameWrapper = iFrame.parentElement;
                    iFrameWrapper.style.display = "block";
                } else {
                    iFrame.style.display = "block";
                }
            } else {
                if(isBackend === "0") {
                    // Dont show iFrame if cookies are not accepted
                    if (iFrame.dataset.hidetopbar === "1") {
                        let iFrameWrapper = iFrame.parentElement;
                        iFrameWrapper.style.display = "none";
                    } else {
                        iFrame.style.display = "none";
                    }
                }
            }
        } else {
            // If no serviceId is set we expect that the service is not cookie related, and we load the iframe
            iFrame.setAttribute("src", iFrameSrc);
        }
    }



    $(function () {

        var iFrames = document.querySelectorAll('[data-html-element="main_iframe"]');

        if (iFrames) {
            iFrames.forEach((iFrame) => {
                checkIfUCServiceAccepted(iFrame);
                window.addEventListener('UC_UI_CMP_EVENT', (e) => {
                    let uc_eventType = e.detail.type;
                    if (uc_eventType === "ACCEPT_ALL" || uc_eventType === "DENY_ALL" || uc_eventType === "SAVE") {
                        checkIfUCServiceAccepted(iFrame);
                    }
                })
            })
        }
    })

})();
